<template>
  <div>
    <div :class="$style.img" :style="{ backgroundImage: `url(${item.image})` }"></div>
    <transition name="slide-down-fade">
      <div v-if="show" :class="$style.footer">
        Поделиться
        <div :class="$style.buttons">
          <div v-for="button in item.buttons" :key="button"
               :class="[$style.button, activeBtn === button && $style.active, errorBtn === button && $style.red]"
               @click="setActive(button)">
            <simple-svg :src="require(`./assets/${buttons[button].image}`)" width="1.8rem" height="1.8rem"/>
            {{buttons[button].title}}
          </div>
        </div>
        <button :class="$style.next" @click="check">Продолжить</button>
      </div>
    </transition>
  </div>

</template>
<script>
import buttons from '@/views/lesson2/components/trainer2/buttons'

export default {
  name: 'share',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      buttons,
      activeBtn: this.item.buttons[0],
      errorBtn: null,
      show: null,
    }
  },
  computed: {
  },
  methods: {
    setActive(id) {
      this.errorBtn = null
      this.activeBtn = id
    },
    check() {
      const { activeBtn, item } = this
      if (activeBtn === item.rightButton) {
        this.$emit('success')
      } else {
        const { title } = item.errors.filter(e => e.button === activeBtn)[0]
        this.$emit('error', title)
        this.errorBtn = activeBtn
      }
    },
    init() {
      this.show = true
    },
  },
  mounted() {
    setTimeout(() => this.init(), 500)
  },
}
</script>
<style lang="scss" module src="./share.scss"></style>
